import { render, staticRenderFns } from "./MotoboyAddOrderSidebar.vue?vue&type=template&id=4dc57298&scoped=true&"
import script from "./MotoboyAddOrderSidebar.vue?vue&type=script&lang=js&"
export * from "./MotoboyAddOrderSidebar.vue?vue&type=script&lang=js&"
import style0 from "./MotoboyAddOrderSidebar.vue?vue&type=style&index=0&id=4dc57298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc57298",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dc57298')) {
      api.createRecord('4dc57298', component.options)
    } else {
      api.reload('4dc57298', component.options)
    }
    module.hot.accept("./MotoboyAddOrderSidebar.vue?vue&type=template&id=4dc57298&scoped=true&", function () {
      api.rerender('4dc57298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/delivery-dashboard/components/MotoboyAddOrderSidebar.vue"
export default component.exports